export default __webpack_public_path__ + "static/media/purpleSearchCircle.064ff8db.svg";